































































































































































































































































































































































































































































































import Vue from 'vue';
import vuex from '@/store';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import MQTT from '@/modules/MQTT';
import { Global, Groups, User, Reports, Props } from '@/store';
import PropUtils from '@/modules/PropUtils';
import Utils from '@/modules/Utils';
import MultipleSearchFilter from '@/components/MultipleSearchFilter.vue';
import DimmingDialog from '@/components/dialogs/DimmingDialog.vue';
import LoadingDialog from '@/components/dialogs/LoadingDialog.vue';
import cloneDeep from 'lodash/cloneDeep';
import ExportData from '@/components/ExportData.vue';
import { setDeviceProperty } from '@/modules/ApiUsers';
import API, { Types } from '@/modules/API';
import ConfirmDialog from '@/components/dialogs/ConfirmDialog.vue';
import VirtualScrollList from '@/components/VirtualScrollList.vue';
import DatePicker from '@/pages/reports/components/DatePicker.vue';
import moment from 'moment';
import { canManageRetrofit, isCabinetDevice, runRetrofitBatch, resolveRetrofitEntryDate, RETROFIT_STATE, PARTIAL_RETROFIT_STATE, DELIVERED_STATE, setCabinetOperationState } from '@/modules/retrofitActions';
// import * as Sentry from '@sentry/vue';

@Component({
  components: {
    MultipleSearchFilter,
    ExportData,
    DimmingDialog,
    LoadingDialog,
    ConfirmDialog,
    VirtualScrollList,
    DatePicker
  }
})
class ManageSelectedDevices extends Vue {
  @Prop() devices;
  @Prop() groupDevices;
  @Prop() createMode;
  @Prop() group;

  @Global.State('readonly_user') readonly_user;
  @Global.State('lang') lang;
  @Global.State('timezone') timezone;
  @Global.State('mqtt_version_by_class') mqtt_version_by_class;
  @Global.State('disable_group_control') disable_group_control;
  @Groups.Action('edit') edit;
  @Groups.Action('create') create;
  @Groups.State('list') groups;
  @User.State('project') project;
  @Reports.Getter('commissioned_map') commissioned_map;
  @Props.State('fixture_meta_device_options') fixture_meta_device_options;
  @Props.State('cabinet_meta_device_options') cabinet_meta_device_options;
  @Props.State('list') projectProperties;

  groupName: string = '';
  groupDescription: string = '';
  mqtt = MQTT.instance;
  search = '';
  cabinet_search = '';
  new_cabinet_message = `I know that this ID doesn't exist in the system and I'm responsible for the consequences`;
  show_new_message = false;
  allChecked = false;
  isChecked = {};
  nameError: any = [];
  saveError: string = '';
  loading = true;
  filterDialog = false;
  deviceTypes = ['tondo'];
  filter_fields = [];
  filter_groups = [];
  filter_group_device_ids: Set<string> = new Set();
  checkedDevices = null;
  rowsPerPageItems = [5, 10, 20];
  pagination = { rowsPerPage: 5 };
  tab = 'main';
  exportFields = null;
  exportedData = null;
  allDevicesData = null;
  insertFieldsOptions = null;
  inputs = null;
  err = null;
  PropUtils = PropUtils;
  selectedGroup = null;
  dimmingDialog: boolean = false;
  dimming_converting_table = null;
  converted: boolean = false;
  percentToDaliTable: any = null;
  controlled_devices: any[] = [];
  loadingDialog: boolean = false;
  prop_utils = PropUtils;
  mode = -1;
  confirmDialog = false;
  devices_id_options = [];
  cabinets_id_options = [];
  optional_cabinet_id_options = [];
  polygon_export_fields_prop = null;
  // Default polygon-export column when the project has no `dashboard.polygon_export_fields`
  // property. `sys___active__modified` is part of the streamed `base_columns`, so the value
  // is already on the device - no extra fetch.
  SYS_ACTIVE_MODIFIED_FIELD_NAME = 'sys___active__modified';
  SYS_ACTIVE_MODIFIED_FIELD = 'Active Status Last Changed';
  select_all = false;
  retrofit_confirm_dialog = false;
  retrofit_direction = 'mark';
  retrofit_running = false;
  retrofit_progress = { done: 0, total: 0 };
  retrofit_results: any[] = [];
  // The exact device list the last batch ran on. Retry has to work off this and not off
  // `retrofit_devices`: a device whose operation_state step succeeded before a later step
  // failed is already in the target state, so the eligibility filter drops it and there
  // would be nothing left to retry.
  retrofit_batch_devices: any[] = [];
  // 'YYYY-MM-DD'. The chosen day is stamped with the current time of day (see
  // resolveRetrofitEntryDate), so an untouched picker resolves to now.
  retrofit_entry_date = moment().format('YYYY-MM-DD');

  rules = {
    required: (value) => !!value || 'Required.'
  };

  mounted() {
    this.loading = true;
    Vue.set(this, 'filter_fields', []);
    Vue.set(this, 'filter_groups', []);
    this.setIsChecked();
    this.setCabinetIdOptions();

    const insertedFields = this.$store.state.Props.list.find((prop) => prop.name === 'dashboard.form_meta_device');
    if (insertedFields && insertedFields.hasOwnProperty('value') && insertedFields.value.hasOwnProperty('fields')) {
      this.insertFieldsOptions = insertedFields.value.fields;
      const inputs = {};
      this.insertFieldsOptions.forEach((field) => inputs[field.name] = '');
      this.inputs = inputs;
    }
    this.polygon_export_fields_prop = PropUtils.getProjectPropertyData(this.projectProperties, 'dashboard.polygon_export_fields');
    this.loading = false;
  }

  setCabinetIdOptions(){
    this.devices_id_options = this.fixture_meta_device_options.cabinet_id || [];
    this.cabinets_id_options = this.cabinet_meta_device_options.cabinet_id || [];
    this.updateOptionalCabinetIds();
  }

  @Watch('cabinet_search')
  updateCabinetID(){
    this.show_new_message = !this.cabinet_search ? false : this.checkNewCabinetID();
  }

  checkNewCabinetID(){
    return !this.optional_cabinet_id_options.includes(this.cabinet_search);
  }

  updateOptionalCabinetIds(){
    this.optional_cabinet_id_options = [...new Set(this.devices_id_options.concat(this.cabinets_id_options))];
    this.optional_cabinet_id_options.sort((c1, c2) => c1.localeCompare(c2, undefined, {numeric: true, sensitivity: 'base'}));
    this.optional_cabinet_id_options.push('');
  }

  get deviceModes(){
    return [
      { text: this.$t('Maintenance'), value: -1},
      { text: this.$t('Fault In Care'), value: -9}
    ];
  }

  get title() {
    return this.tab === 'main'
      ? 'Manage Selected Devices'
      : this.tab === 'choose'
      ? 'Select an Action'
      : this.tab === 'export'
      ? 'Export Data'
      : this.tab === 'insert'
      ? 'Insert Data'
      : this.tab === 'command'
      ? 'Send Command'
      : this.tab === 'group'
      ? 'Create Group'
      : this.tab === 'status'
      ? 'Update Device Status'
      : this.tab === 'retrofit'
      ? this.retrofit_action_label
      : '';
  }

  get buttonText() {
    return 'Set';
  }

  toggleDevice(device, checked) {
    this.$set(this.isChecked, device.id, checked);
    this.updateDevices(device);
  }

  get show_retrofit_actions() {
    return canManageRetrofit() && this.$route.path.includes('cabinet-details');
  }

  // Devices under Retrofit / pending verification have no schedule, can't be
  // controlled and shouldn't change status, so every action that acts on the
  // devices themselves must skip them.
  get live_selected_devices() {
    return this.selected_devices_data.filter((device: any) => Utils.isDeviceLive(device));
  }

  // Group membership only needs the device to be present, so it blocks Retrofit
  // devices alone - a pending-verification one is already back (Delivered,
  // waiting to reconnect) and can be grouped.
  get groupable_selected_devices() {
    return this.selected_devices_data.filter((device: any) => !Utils.isDeviceUnderRetrofit(device));
  }

  get retrofit_blocked_count() {
    return this.selected_devices_data.length - this.live_selected_devices.length;
  }

  get group_blocked_count() {
    return this.selected_devices_data.length - this.groupable_selected_devices.length;
  }

  get all_selected_under_retrofit() {
    return !!this.selected_devices_data.length && !this.live_selected_devices.length;
  }

  get all_selected_blocked_for_group() {
    return !!this.selected_devices_data.length && !this.groupable_selected_devices.length;
  }

  get retrofit_excluded_from_action() {
    return this.retrofit_blocked_count > 0;
  }

  get retrofit_exclusion_message() {
    return this.all_selected_under_retrofit
      ? this.$t('All selected devices are under Retrofit and are excluded from this action')
      : `${this.retrofit_blocked_count} ${this.$t('of')} ${this.selected_devices_data.length} ${this.$t('selected devices are under Retrofit and are excluded from this action')}`;
  }

  get group_exclusion_message() {
    return this.all_selected_blocked_for_group
      ? this.$t('All selected devices are under Retrofit and are excluded from this action')
      : `${this.group_blocked_count} ${this.$t('of')} ${this.selected_devices_data.length} ${this.$t('selected devices are under Retrofit and are excluded from this action')}`;
  }

  // icon names must exist in the loaded mdi font (3.0.39), newer names render empty
  get action_cards() {
    const blue = '#292F7D', blue_tint = '#EDEEF7';
    // Export / Insert Data only read or edit metadata, so they stay available
    // for devices under Retrofit.
    const retrofit_blocked = this.all_selected_under_retrofit;
    // Create Group accepts pending-verification devices, so it is only blocked
    // when every selected device is actually out for Retrofit.
    const group_blocked = this.all_selected_blocked_for_group;
    const retrofit_reason = 'All selected devices are under Retrofit';

    return [
      { name: 'export', label: 'Export Data', icon: 'mdi-download', color: blue, tint: blue_tint, disabled: false, disabled_reason: '' },
      { name: 'insert', label: 'Insert Data', icon: 'mdi-pencil', color: blue, tint: blue_tint, disabled: this.readonly_user, disabled_reason: '' },
      { name: 'command', label: 'Send Command', icon: 'mdi-remote', color: blue, tint: blue_tint, disabled: this.readonly_user || retrofit_blocked, disabled_reason: retrofit_blocked ? retrofit_reason : '' },
      { name: 'group', label: 'Create Group', icon: 'mdi-folder-plus', color: blue, tint: blue_tint, disabled: this.readonly_user || group_blocked, disabled_reason: group_blocked ? retrofit_reason : '' },
      { name: 'status', label: 'Update Status', icon: 'mdi-swap-horizontal', color: blue, tint: blue_tint, disabled: this.readonly_user || retrofit_blocked, disabled_reason: retrofit_blocked ? retrofit_reason : '' }
    ];
  }

  get retrofit_action_cards() {
    if (!this.show_retrofit_actions) return [];

    const blue = '#292F7D', blue_tint = '#EDEEF7';

    return [
      { name: 'mark_retrofit', label: 'Mark as Retrofit', icon: 'mdi-wrench', color: blue, tint: blue_tint, disabled: false },
      { name: 'return_retrofit', label: 'Return from Retrofit', icon: 'mdi-backup-restore', color: blue, tint: blue_tint, disabled: false }
    ];
  }

  selectAction(action) {
    if (action.disabled) return;
    if (action.name === 'mark_retrofit' || action.name === 'return_retrofit') {
      this.openRetrofitTab(action.name === 'mark_retrofit' ? 'mark' : 'return');
      return;
    }
    this.tab = action.name;
  }

  @Watch('$route')
  resetTabOnRouteChange() {
    if (this.tab === 'retrofit' && !this.show_retrofit_actions) {
      this.closeRetrofitTab();
    }
  }

  get selected_devices_data() {
    return [...this.groupDevices.values()].map(
      (device: any) => this.$store.state.Reports.reportsList.find((dev) => dev.id === device.id) || device
    );
  }

  get is_mark_retrofit() {
    return this.retrofit_direction === 'mark';
  }

  get retrofit_footer_stage() {
    if (this.retrofit_running) return null;
    if (this.retrofit_results.length) return 'results';
    return 'confirm';
  }

  get show_footer() {
    if (this.tab === 'choose') return false;
    if (this.tab === 'retrofit') return !!this.retrofit_footer_stage;
    return true;
  }

  get retrofit_action_label() {
    return this.is_mark_retrofit ? 'Mark as Retrofit' : 'Return from Retrofit';
  }

  // The operation state property isn't mirrored into the devices store (tab-only
  // field), so devices with an unknown state stay eligible - every step is
  // idempotent, and the device's real state is authoritative on the backend.
  isRetrofitEligible(device) {
    const operation_state = Utils.getOperationState(device);
    // Partial Retrofit is a cabinet-only derived state, and a cabinet in it is
    // still on its way out of Retrofit - so it must stay returnable.
    if (!this.is_mark_retrofit) {
      return !operation_state || operation_state === RETROFIT_STATE || operation_state === PARTIAL_RETROFIT_STATE;
    }
    // A cabinet already in Retrofit stays eligible: unlike a fixture it carries
    // services.config and meta.devices_schedule too, and those may still be
    // unchanged (moved to Retrofit before they were part of the flow, or a run that
    // failed halfway). The sequence re-checks them and leaves the state and the
    // retrofit record it already has untouched.
    if (isCabinetDevice(device)) return true;
    return operation_state !== RETROFIT_STATE;
  }

  // A cabinet_id resolves to several cabinet-class rows when the cabinet also
  // has virtual cabinets (meta.category.virtual, category 'hub'), so the real
  // controller - the row that carries the cabinet's operation state, services
  // and schedule - must be preferred over them.
  resolveCabinetController(all_cabinets, cabinet_id) {
    const matches = all_cabinets.filter(
      (cabinet) => cabinet['meta.device'] && cabinet['meta.device'].cabinet_id === cabinet_id
    );
    if (!matches.length) return null;
    return matches.find(
      (cabinet) => !Utils.hasVirtualCabinetClass(cabinet['meta.category']) && cabinet.class_name !== 'virtual_cabinet'
    ) || matches[0];
  }

  get retrofit_auto_included_controllers() {
    const cabinet_ids_with_selection = new Set<string>();
    this.selected_devices_data.forEach((device: any) => {
      const cabinet_id = device['meta.device'] && device['meta.device'].cabinet_id;
      if (!cabinet_id || isCabinetDevice(device)) return;
      cabinet_ids_with_selection.add(cabinet_id);
    });

    const all_devices = this.$store.getters['Reports/commissionedDevices'] || [];
    const all_cabinets = this.$store.getters['Reports/commissionedCabinets'] || [];
    const selected_ids = new Set(this.selected_devices_data.map((device: any) => device.id));
    const controllers = [];

    cabinet_ids_with_selection.forEach((cabinet_id: string) => {
      // the cabinet controller itself also carries meta.device.cabinet_id, so it
      // must be excluded from the fixture list
      const cabinet_fixtures = all_devices.filter(
        (device) =>
          device['meta.device'] &&
          device['meta.device'].cabinet_id === cabinet_id &&
          !Utils.hasCabinetClass(device['meta.category'] && device['meta.category'].category)
      );
      if (!cabinet_fixtures.length) return;

      // The controller only needs to cascade once every fixture of the cabinet ends
      // up in the target state after this action - either because it's selected now,
      // or because it's already in the target state and will be left untouched.
      const all_fixtures_covered = cabinet_fixtures.every(
        (device) => selected_ids.has(device.id) || !this.isRetrofitEligible(device)
      );
      if (!all_fixtures_covered) return;

      const controller = this.resolveCabinetController(all_cabinets, cabinet_id);
      if (controller && !selected_ids.has(controller.id) && this.isRetrofitEligible(controller)) {
        controllers.push(controller);
      }
    });

    return controllers;
  }

  get retrofit_eligible_devices() {
    return this.selected_devices_data.filter((device: any) => this.isRetrofitEligible(device));
  }

  get retrofit_devices() {
    const eligible_ids = new Set(this.retrofit_eligible_devices.map((device: any) => device.id));
    const controllers = this.retrofit_auto_included_controllers.filter((device: any) => !eligible_ids.has(device.id));
    return [...this.retrofit_eligible_devices, ...controllers];
  }

  get retrofit_excluded_count() {
    return this.selected_devices_data.length - this.retrofit_eligible_devices.length;
  }

  getRetrofitDeviceTypeLabel(device: any) {
    const category = device['meta.category'] && device['meta.category'].category;
    const class_name = device.class_name;

    if (Utils.hasVirtualControllerClass(class_name)) return 'virtual controller';
    if (Utils.hasVirtualCabinetClass(device['meta.category'])) return 'virtual cabinet';
    if (isCabinetDevice(device)) return 'cabinet controller';
    if (Utils.hasFloodSensorClass(category)) return 'flood sensor';
    if (Utils.hasMotionSensorClass(class_name)) return 'motion sensor';
    if (Utils.hasBarrierClass(category)) return 'barrier';
    if (Utils.hasCameraClass(category) || Utils.hasVideoClass(class_name)) return 'camera';
    if (Utils.hasWaterMeterClass(class_name)) return 'water meter';
    if (Utils.hasWeatherStationClass(class_name)) return 'weather station';
    if (Utils.hasTondoClass(category)) return 'fixture';
    return 'device';
  }

  pluralizeRetrofitLabel(label: string) {
    return `${label}s`;
  }

  get retrofit_type_counts() {
    const counts = new Map<string, number>();
    this.retrofit_devices.forEach((device: any) => {
      const label = this.getRetrofitDeviceTypeLabel(device);
      counts.set(label, (counts.get(label) || 0) + 1);
    });
    return counts;
  }

  get retrofit_summary_noun() {
    return [...this.retrofit_type_counts.entries()]
      .map(([label, count]) => `${count} ${this.$t(count === 1 ? label : this.pluralizeRetrofitLabel(label))}`)
      .join(', ');
  }

  get retrofit_summary_outcome() {
    return this.is_mark_retrofit
      ? this.$t('will be marked as Retrofit')
      : this.$t('will be returned from Retrofit');
  }

  get formatted_retrofit_entry_date() {
    return moment(this.retrofit_entry_date, 'YYYY-MM-DD').format('DD-MM-YYYY');
  }

  get retrofit_confirm_text() {
    return `${this.retrofit_summary_noun} ${this.retrofit_summary_outcome}.`;
  }

  get retrofit_confirm_items() {
    const items = [...this.retrofit_consequences];

    // Always state the date being recorded, not only when it was changed - the default
    // is just as consequential, and the user shouldn't have to remember what the picker
    // said. Composed here rather than in the text, which reads as a dangling date.
    //
    // No colon in this sentence on purpose: ConfirmDialog runs every item through $t(),
    // and i18next's default nsSeparator is ':', so it would treat everything before the
    // colon as a namespace and render only the tail (which is exactly what the previous
    // "Retrofit start date: <date>" wording did).
    if (this.is_mark_retrofit) {
      items.push(`${this.$t('Retrofit will be recorded as starting on')} ${this.formatted_retrofit_entry_date}`);
    }

    if (this.retrofit_auto_included_controllers.length) {
      items.push(this.is_mark_retrofit
        ? 'The cabinet controller will be marked as Retrofit as well'
        : 'The cabinet controller will be returned from Retrofit as well');
    }

    return items;
  }

  get retrofit_device_names() {
    return this.retrofit_devices
      .map((device: any) => device.name || device.id)
      .sort((a, b) => (a > b ? 1 : -1));
  }

  get retrofit_consequences() {
    return this.is_mark_retrofit
      ? [
        'Devices stop raising alerts',
        'Devices cannot be controlled until returned from Retrofit',
        'Existing schedules and dimming curves are deleted'
      ]
      : [
        'Devices resume raising alerts and can be controlled',
        'Devices are marked as pending verification until they reconnect',
        'Deleted schedules and dimming curves are not restored'
      ];
  }

  get retrofit_progress_percent() {
    return this.retrofit_progress.total
      ? Math.round((this.retrofit_progress.done / this.retrofit_progress.total) * 100)
      : 0;
  }

  get retrofit_succeeded() {
    return this.retrofit_results.filter((result) => result && result.status === 'success');
  }

  get retrofit_failed() {
    return this.retrofit_results.filter((result) => !result || result.status !== 'success');
  }

  get today() {
    return moment().format('YYYY-MM-DD');
  }

  openRetrofitTab(direction) {
    this.retrofit_direction = direction;
    this.retrofit_results = [];
    this.retrofit_batch_devices = [];
    this.retrofit_progress = { done: 0, total: 0 };
    // The panel survives between actions, so a date picked for an earlier batch must not
    // silently carry over into the next one.
    this.retrofit_entry_date = this.today;
    this.tab = 'retrofit';
  }

  closeRetrofitTab() {
    this.retrofit_results = [];
    this.retrofit_batch_devices = [];
    this.retrofit_progress = { done: 0, total: 0 };
    this.tab = 'choose';
  }

  confirmRetrofitAction() {
    this.retrofit_confirm_dialog = false;
    this.runRetrofitDevicesBatch(this.retrofit_devices);
  }

  retryFailedRetrofit() {
    const failed_ids = new Set(this.retrofit_failed.map((result) => result && result.device_id));
    const devices = this.retrofit_batch_devices.filter((device: any) => failed_ids.has(device.id));
    if (!devices.length) return;
    this.runRetrofitDevicesBatch(devices);
  }

  async runRetrofitDevicesBatch(devices) {
    this.retrofit_batch_devices = devices;
    this.retrofit_results = [];
    this.retrofit_progress = { done: 0, total: devices.length };
    this.retrofit_running = true;

    const results = await runRetrofitBatch(devices, this.retrofit_direction as any, (done, total) => {
      this.retrofit_progress = { done, total };
    }, this.retrofit_entry_date);

    this.retrofit_running = false;
    this.retrofit_results = results;

    await this.reconcileCabinetRetrofitStates(devices);

    const failed_count = results.filter((result) => !result || result.status !== 'success').length;
    this.$store.dispatch('Global/throwNotify', {
      type: failed_count ? 'error' : 'success',
      title: failed_count ? this.$t('Error') : this.$t('Success'),
      text: failed_count
        ? `${this.$t('Failed')}: ${failed_count} ${this.$t('of')} ${results.length} ${this.$t('devices')}`
        : this.$t(
          this.is_mark_retrofit
            ? 'All selected devices were marked as Retrofit'
            : 'All selected devices were returned from Retrofit'
        )
    });

    this.$emit('changeDevicesData');
  }

  async reconcileCabinetRetrofitStates(devices) {
    // cabinets whose controller was itself part of this batch already went
    // through the full mark/return sequence and have their final state set
    const controller_ids = new Set(
      devices.filter((device: any) => isCabinetDevice(device)).map((device: any) => device.id)
    );

    const cabinet_ids = new Set<string>();
    devices.forEach((device: any) => {
      if (isCabinetDevice(device)) return;
      const cabinet_id = device['meta.device'] && device['meta.device'].cabinet_id;
      if (cabinet_id) cabinet_ids.add(cabinet_id);
    });

    const all_devices = this.$store.getters['Reports/commissionedDevices'] || [];
    const all_cabinets = this.$store.getters['Reports/commissionedCabinets'] || [];

    for (const cabinet_id of cabinet_ids) {
      const controller = this.resolveCabinetController(all_cabinets, cabinet_id);
      if (!controller || controller_ids.has(controller.id)) continue;

      const cabinet_fixtures = all_devices.filter(
        (device) =>
          device['meta.device'] &&
          device['meta.device'].cabinet_id === cabinet_id &&
          !isCabinetDevice(device)
      );
      if (!cabinet_fixtures.length) continue;

      const retrofit_count = cabinet_fixtures.filter((device: any) => {
        const operation_state = Utils.getOperationState(device);
        return operation_state === RETROFIT_STATE || operation_state === PARTIAL_RETROFIT_STATE;
      }).length;

      const controller_state = Utils.getOperationState(controller);

      // Returning the last retrofit fixture has to take the cabinet out of
      // Retrofit / Partial Retrofit too - but only cabinets that are in one of
      // those derived states, so cabinets in any other state stay untouched.
      if (!retrofit_count && controller_state !== RETROFIT_STATE && controller_state !== PARTIAL_RETROFIT_STATE) continue;

      const target_state = !retrofit_count
        ? DELIVERED_STATE
        : retrofit_count === cabinet_fixtures.length
          ? RETROFIT_STATE
          : PARTIAL_RETROFIT_STATE;
      // Already being in the target state doesn't mean there's nothing left to do:
      // setCabinetOperationState re-checks the properties that go with Retrofit
      // (services.config, meta.devices_schedule) and with Partial Retrofit (the
      // Power/Schedule validation service) while leaving the state itself alone.
      // 'delivered' carries no such side effects, so it's still skipped.
      if (controller_state === target_state && target_state === DELIVERED_STATE) continue;

      // A cabinet whose state is derived from the fixtures just marked should carry the
      // same entry date they did, so the controller and its fixtures don't disagree on
      // when the cabinet went under Retrofit. Returning keeps stamping the current time.
      await setCabinetOperationState(
        controller,
        target_state,
        target_state === DELIVERED_STATE ? undefined : resolveRetrofitEntryDate(this.retrofit_entry_date)
      );
    }
  }

  async handleGroupAction() {
    if (!this.groupName) {
      this.nameError = ['Name is required'];
      return;
    }
    if (!this.groupDevices.size) {
      vuex.dispatch('Global/throwNotify', {
        type: 'error',
        title: `${this.$t('Error')}!`,
        text: this.$t(`You must choose at least one device`)
      });
      return;
    }
    if (!this.groupable_selected_devices.length) {
      vuex.dispatch('Global/throwNotify', {
        type: 'error',
        title: `${this.$t('Error')}!`,
        text: this.$t('All selected devices are under Retrofit and cannot be added to a group')
      });
      return;
    }
    if (this.groups.length) {
      if (
        this.groups.some(
          (group) =>
            group.name.trim().toLowerCase() ===
            this.groupName.trim().toLowerCase()
        )
      ) {
        this.nameError = ['Name already exists'];
        return;
      }
    }
    await this.createGroup();
    this.sendDeviceCommand();
    if (this.group_blocked_count) {
      vuex.dispatch('Global/throwNotify', {
        type: 'info',
        title: this.$t('Info'),
        text: `${this.group_blocked_count} ${this.$t('devices under Retrofit were excluded from the group')}`
      });
    }
    this.tab = 'main';
  }

  async handleChangeClicked(){
    this.confirmDialog = false;
    this.loadingDialog = true;
    const excluded_count = this.retrofit_blocked_count;
    const selected_devices = this.live_selected_devices.map((device: any) => device.id);
    const slices = Math.ceil(selected_devices.length / 100);
    let startIndex = 0, endIndex = Math.min(selected_devices.length, 100);
    for (let i = 0; i < slices; i++){
      const current = selected_devices.slice(startIndex, endIndex);
      await Promise.all(current.map( async (device_id) => await this.updateDeviceMode(device_id, this.mode)));
      startIndex = endIndex;
      endIndex = Math.min(selected_devices.length, endIndex + 100);
    }

    this.loadingDialog = false;

    if (excluded_count) {
      this.$store.dispatch('Global/throwNotify', {
        type: 'info',
        title: this.$t('Info'),
        text: `${excluded_count} ${this.$t('devices under Retrofit were skipped')}`
      });
    }
  }

  updateDeviceMode(device_id, mode){
    return API.post('', `${Types.PROJECTS}/${this.project.id}/${Types.DEVICES}/${device_id}/streams/sys___active/evt/`, { content: mode }, {}, 'v4');
  }

  notifyStatus(isCompleted){
    const notifyData = isCompleted
      ? {
        text: 'Devices mode updated successfully!',
        type: 'success',
        title: 'Success!'
      } : {
        text: 'Some mode devices could not update. Please try again later.',
        type: 'error',
        title: 'Error!'
      };
    
    this.$notify(notifyData);
  }

  get devicesList() {
    const prevDevicesIds = [];
    for (const key in this.isChecked) {
      if (this.isChecked[key]) {
        prevDevicesIds.push(key);
      }
    }
    const prevDevices = [];
    for (const i of prevDevicesIds) {
      prevDevices.push(this.devices.find((dev) => dev.id === i));
    }

    let currentDevices = this.hasActiveFilter
      ? this.getDevicesByFilter()
      : this.devices;
    currentDevices = currentDevices.filter(
      (dev) => prevDevicesIds.indexOf(dev.id) < 0
    );
    currentDevices = currentDevices.concat(prevDevices);

    const devicesBySearch = currentDevices.filter((v) =>
      v.name.toLowerCase().includes(this.search.toLowerCase())
    );
    this.allChecked = devicesBySearch.length === this.groupDevices.size;
    if (this.allChecked) {
      for (const index of currentDevices) {
        this.isChecked[index.id] = true;
      }
      this.checkedDevices = currentDevices;
    }
    return devicesBySearch.sort((device1, device2) =>
      device1.name.localeCompare(device2.name)
    );
  }

  get hasActiveFilter() {
    return !!(this.filter_fields.length || this.filter_group_device_ids.size);
  }

  getDevicesByFilter() {
    let filter_devices = cloneDeep(this.devices);
    if (this.filter_fields.length) {
      filter_devices = filter_devices.filter((device) => {
        return this.filter_fields.every((field) => {
          const field_value = this.commissioned_map.get(device.id)['meta.device'][field.name];
          if (!field_value) return false;
          return field.selected.includes(field_value.toString());
        });
      });
    } else if (this.filter_group_device_ids.size) {
      filter_devices = [];
    }

    if (this.filter_group_device_ids.size) {
      const merged = new Map(filter_devices.map((device) => [device.id, device]));
      cloneDeep(this.devices)
        .filter((device) => this.filter_group_device_ids.has(device.id))
        .forEach((device) => merged.set(device.id, device));
      filter_devices = [...merged.values()];
    }
    return filter_devices;
  }

  // Fetches the member device ids for the selected groups (group list objects
  // don't carry their device ids, only the count) so `getDevicesByFilter` can
  // union them with the meta.device field matches synchronously.
  async fetchGroupDeviceIds(group_ids: string[]): Promise<Set<string>> {
    if (!group_ids || !group_ids.length) return new Set();
    try {
      const groups_data = await Promise.all(
        group_ids.map((group_id) => API.get(Types.PROJECTS, `${this.project.id}/groups/${group_id}`, {}, {}, 'v4'))
      );
      const ids = new Set<string>();
      groups_data.forEach((group) => (group.devices || []).forEach((id) => ids.add(id)));
      return ids;
    } catch (e) {
      console.warn('Failed to fetch devices for the selected groups', e);
      return new Set();
    }
  }

  setFilterDialogOpen() {
    this.filterDialog = !this.filterDialog;
  }

  selectField() {
    this.select_all = this.exportFields.every((export_field) => export_field.selected);
    this.setExportedData();
  }

  selectAllExportFields(){
    this.exportFields.forEach((export_field) => export_field.selected = this.select_all);
    this.setExportedData();
  }

  clearPolygonData(){
    this.$emit('clearPolygonData');
  }

  async handleDevicesEdit() {
    this.err = '';
    const inputs = { ...this.inputs };
    for (const field in inputs) {
      if (inputs[field].length === 0) {
        delete inputs[field];
      } else {
        inputs[field] = inputs[field].trim();
      }
    }
    if (Object.keys(inputs).length === 0) {
      this.err = 'You have to insert at least one field value';
      return;
    }
    for (const f in inputs) {
      const fieldOption = this.insertFieldsOptions.find((option) => option.name === f);
      if (fieldOption.type === 'number') {
        const value = parseInt(inputs[f], 10);
        if (isNaN(value)) {
          this.err = `The value of ${f} should be a valid number`;
          return;
        } else {
          if (
            fieldOption.hasOwnProperty('range') &&
            (value < fieldOption.range.min || value > fieldOption.range.max)
          ) {
            this.err = `The value of ${f} is not in range`;
            return;
          }
        }
      }
    }
    if (this.err.length === 0) {
      let notifySuccess = false;
      Object.entries(inputs).map(([field, value]) => inputs[field] = Utils.removeLeadingZeroesAndSpaces(value));
      const devices = Array.from(this.groupDevices.values());
      try {
        devices.forEach(async (device: any) => {
          let metaDevice = device['meta.device'];
          if (metaDevice.hasOwnProperty('fixture_icon') && metaDevice.fixture_icon === 'Virtual') {
            metaDevice = { ...metaDevice, ...inputs, fixture_icon: 'Virtual' };
            this.$notify({
              type: 'error',
              title: 'Warning',
              text: 'Virtual device icon can not be changed'
            });
          } else {
            metaDevice = { ...metaDevice, ...inputs };
            notifySuccess = true;
          }
          const response_ok = await setDeviceProperty(device.id, 'meta.device', metaDevice);
          if (response_ok){
            vuex.commit('Reports/editDeviceField', {device_id: device.id, name: 'meta.device', value: metaDevice});
          }
        });
        if (
          notifySuccess ||
          Object.keys(inputs).length > 1 ||
          Object.keys(inputs)[0] !== 'fixture_icon'
        ) {
          this.$notify({
            type: 'success',
            title: 'Success',
            text: 'All changes have been saved successfully'
          });
        }
        this.$emit('changeDevicesData');
        this.tab = 'choose';
      } catch (e) {
        console.log(e);

        this.$notify({
          type: 'error',
          title: 'Warning',
          text: 'Something went wrong'
        });
      }
    }
  }

  @Watch('checkedDevices')
  setcheckedDevices() {
    if (this.checkedDevices.length === 0) {
      this.tab = 'main';
      return;
    }

    const exported = [], property_paths = new Set();

    if (this.polygon_export_fields_prop) {
      this.polygon_export_fields_prop.forEach((field) => {
        if (field.hasOwnProperty('inner_fields') && Object.keys(field.inner_fields).length) {
          Object.entries(field.inner_fields).forEach(([inner_field_name, data]) => {
            const text_field = data[this.lang];
            exported.push({field: text_field, selected: data['selected'], field_name: field.name, inner: inner_field_name});
            property_paths.add(`${field.name}.${inner_field_name}`);
          });
        }else {
          exported.push({field: field[this.lang], selected: field.selected, field_name: field.name});
          property_paths.add(field.name);
        }
      });
    }

    // The built-in columns are always offered, so a project that configures
    // `dashboard.polygon_export_fields` gets them on top of its own list. A column the
    // property already defines wins - matched on the device field it reads, not on its
    // label, so the same data never shows up twice under two different titles.
    this.getDefaultExportFields()
      .filter((default_field) => !property_paths.has(default_field.path))
      .forEach((default_field) => exported.push(default_field));

    this.exportFields = [...exported].sort((a, b) => a.field.localeCompare(b.field, undefined, {numeric: true, sensitivity: 'base'}));

    this.allDevicesData = [...this.groupDevices.values()].map((device_data) => {
      const export_data = {};
      exported.forEach((field_data) => {
        if (field_data.value) {
          export_data[field_data.field] = field_data.value(device_data);
        } else if (field_data.inner) {
          const path = [...field_data.field_name.split('.'), field_data.inner];
          export_data[field_data.field] = Utils.getNestedValue(device_data, path);
        } else {
          export_data[field_data.field] = device_data[field_data.field_name];
        }
      });
      return export_data;
    });
    this.setExportedData();
  }

  // Built-in polygon export columns. `path` is the device field the column reads, written
  // in the same `name[.inner_field]` shape `dashboard.polygon_export_fields` uses so the
  // two lists can be merged without duplicating a column. Rebuilt on every call: the
  // checkboxes write back into `selected`, so a cached list would leak the previous
  // selection into the next polygon.
  getDefaultExportFields() {
    const meta_device_fields = Object.keys(this.fixture_meta_device_options);
    const selectedfields = ['cabinet_id', 'phase', 'circuit_number', 'watts', 'pole_number', 'pole_height', 'pole_type'];

    return [
      { field: 'Device Id', selected: true, path: 'id', value: (device) => device.id },
      { field: 'Device Name', selected: true, path: 'name', value: (device) => device.name },
      { field: 'Version Number', selected: true, path: 'version_nrf52840', value: (device) => device.version_nrf52840 },
      { field: 'Device Latitude', selected: true, path: 'meta.location.lat', value: (device) => device['meta.location'].lat },
      { field: 'Device Longitude', selected: true, path: 'meta.location.lng', value: (device) => device['meta.location'].lng },
      { field: 'Active Status', selected: true, path: 'sys___active', value: (device) => Utils.getActiveStatusLabel(device) },
      { field: this.SYS_ACTIVE_MODIFIED_FIELD, selected: true, path: this.SYS_ACTIVE_MODIFIED_FIELD_NAME, value: (device) => this.formatSysActiveModified(device) },
      { field: 'Device Commissioner', selected: false, path: 'meta.commission.commissioner', value: (device) => device['meta.commission'].commissioner },
      { field: 'Device Commission Date', selected: false, path: 'meta.commission.date', value: (device) => device['meta.commission'].date },
      ...meta_device_fields.map((field) => ({
        field,
        selected: selectedfields.includes(field),
        path: `meta.device.${field}`,
        // Devices that never got the field still need the column, or the exported rows
        // would not all share the same shape.
        value: (device) => device['meta.device'][field] === undefined ? '' : device['meta.device'][field]
      }))
    ];
  }

  // Raw epoch seconds are meaningless in a spreadsheet, so the timestamp is exported
  // in the project timezone - the same format the device pages display it in.
  formatSysActiveModified(device) {
    const modified = device && device[this.SYS_ACTIVE_MODIFIED_FIELD_NAME];
    return modified ? Utils.convertTimestamp(modified * 1000, 'DD/MM/YYYY HH:mm', this.timezone) : '';
  }

  setExportedData() {
    const devicesData = JSON.parse(JSON.stringify(this.allDevicesData));
    const selected = this.exportFields.filter((field_data) => field_data.selected).map((field_data) => field_data.field);
    const selected_devicesData = devicesData.map((device_data) => {
      const selected_device_fields = {};
      selected.forEach((selected_field) => {
        // The exported header is the label the user picked in the panel, so it goes
        // through the same translation - otherwise the file is always English.
        selected_device_fields[this.translateExportField(selected_field)] = device_data[selected_field];
    });
      return selected_device_fields;
    });
    this.exportedData = selected_devicesData;
  }

  translateExportField(field) {
    return `${this.$t(PropUtils.getFieldLowerToUpper(field))}`;
  }

  @Watch('groupDevices')
  async setIsChecked() {
    this.isChecked = {};
    this.checkedDevices = [];
    this.devices.forEach((device) => (this.isChecked[device.id] = this.groupDevices.has(device.id)));

    const tempCheckedDevices = [];
    for (const device_id in this.isChecked) {
      if (this.isChecked[device_id] === true) {
        if (this.devicesList.find((device) => device.id === device_id)) {
          const deviceName = this.devicesList.find((device) => device.id === device_id)['name'];
          tempCheckedDevices.push({
            id: device_id,
            name: deviceName,
            cabinet: this.commissioned_map.get(device_id)['meta.device'].cabinet_id,
            circuit: this.commissioned_map.get(device_id)['meta.device'].circuit_number,
            pole: this.commissioned_map.get(device_id)['meta.device'].pole_number,
            under_retrofit: !Utils.isDeviceLive(this.commissioned_map.get(device_id))
          });
        }
      }
    }
    this.controlled_devices = tempCheckedDevices
      .map((device) => this.$store.state.Reports.reportsList.find((dev) => dev.id === device.id))
      .filter((device) => device && Utils.isDeviceLive(device));
    if (this.controlled_devices.length) {
      [this.converted, this.percentToDaliTable] =
        await Utils.convertDimmerValues(this.controlled_devices[0].id);
    }
    this.checkedDevices = tempCheckedDevices.sort((a, b) =>
      a.name > b.name ? 1 : -1
    );
  }

  async setPowerLevel(power_percent) {
    this.loadingDialog = true;
    const dali_power = this.converted
      ? this.percentToDaliTable[power_percent]
      : Math.round((power_percent * 254) / 100);
    const slices = Math.ceil(this.controlled_devices.length / 5);
    let startIndex = 0,
      endIndex = Math.min(this.controlled_devices.length, 5);
    let failedDevices = 0;
    const totalDevices = this.controlled_devices.length;
    let notificationShown = false;

    const showNotification = () => {
      if (notificationShown) return;

      notificationShown = true;
      this.loadingDialog = false;

      if (failedDevices === 0) {
        this.$store.dispatch('Global/throwNotify', {
          type: 'success',
          title: this.$t('Success'),
          text: "Command sent to all devices"
        });
      } else {
        this.$store.dispatch('Global/throwNotify', {
          type: 'error',
          title: this.$t('Error'),
          text: `Failed to send command to ${failedDevices} of ${totalDevices} devices`
        });
      }
    };

    try {
      for (let i = 0; i < slices; i++) {
        const current = this.controlled_devices.slice(startIndex, endIndex);
        await Promise.all(
          current.map(async (device) => {
            try {
              await this.updateDevicePower(device.id, dali_power);
              return true;
            } catch (e) {
              try {
                await this.updateDevicePower(device.id, dali_power);
                return true;
              } catch (e) {
                failedDevices++;
                return false;
              }
            }
          })
        );
        startIndex = endIndex;
        endIndex = Math.min(this.controlled_devices.length, endIndex + 5);
      }

      // All API calls completed, show notification immediately
      showNotification();
    } catch (error) {
      // In case of uncaught errors, rely on the timeout
    }

    // Keep the timeout as a fallback
    const timeoutId = setTimeout(() => {
      if (this.loadingDialog) {
        showNotification();
        console.warn(`setPowerLevel timeout`);
        // Sentry.captureMessage(`setPowerLevel timeout`);
      }
    }, 30000);
  }

  updateDevicePower(device_id, power) {
    return API.post(
      '',
      `${Types.PROJECTS}/${this.project.id}/${Types.DEVICES}/${device_id}/streams/power/cmd/`,
      { content: power },
      {},
      'v4'
    );
  }

  async setDevicesList(selected_fields, selected_groups = []) {
    Vue.set(this, 'filter_fields', cloneDeep(selected_fields));
    Vue.set(this, 'filter_groups', cloneDeep(selected_groups));
    this.filter_group_device_ids = await this.fetchGroupDeviceIds(selected_groups);
    const devices = this.getDevicesByFilter();
    this.$emit('selected', devices, true, 'filter');
  }

  sendDeviceCommand() {
    const mqtt_publish_data = {
      message_type: 'cmd',
      format: 'minimal',
      stream_value: 'AT+reload',
      options: {
        retain: false,
        qos: 1
      }
    };

    this.live_selected_devices.forEach((device: any) => {
      let mqtt_version = 3;
      if (this.mqtt_version_by_class.has(device.class_name)) {
        mqtt_version = this.mqtt_version_by_class.get(device.class_name).mqtt_version;
      }
      this.mqtt.publishToSingleDevice({
        ...mqtt_publish_data,
        version_num: mqtt_version,
        device_id: device.id,
        stream_id: mqtt_version === 3 ? `${device.id}.command` : 'command'
      });
    });
  }

  getFilterList() {
    let filter_list_string = '';
    this.filter_fields.forEach((field, index) => {
      filter_list_string = filter_list_string.concat(
        `${field.name}: ${field.selected.join(', ')}`
      );
      if (index < this.filter_fields.length - 1)
        filter_list_string = filter_list_string.concat(', ');
    });

    return filter_list_string;
  }

  async handleSelect() {
    this.tab = 'choose';
  }

   async createGroup() {
    const data = {
      data: {
        project: this.project.id,
        name: this.groupName || '',
        description: this.groupDescription || '',
        devices: this.groupable_selected_devices.map((device: any) => device.id),
        stream_list: 'power'
      },
      project_id: this.project.id
    };
    await this.create(data);
  }

  updateDevices(d) {
    const device = this.$store.state.Reports.reportsList.find((device) => device.id === d.id);
    this.$emit('selected', [{...device}], false);
    this.allChecked = this.devices.length === this.groupDevices.size;
  }

  selectAll() {
    if (this.allChecked) {
      const currentDevices = this.hasActiveFilter
        ? this.getDevicesByFilter()
        : this.devices;
      const selected = currentDevices.filter((v) =>
        v.name.toLowerCase().includes(this.search.toLowerCase())
      );
      this.$emit('selectAll', selected);
    } else this.$emit('selectAll', []);
  }

  clearData() {
    Vue.set(this, 'filter_fields', []);
    Vue.set(this, 'filter_groups', []);
    this.filter_group_device_ids = new Set();
    this.search = '';
    this.checkedDevices = [];
    this.$emit('clear');
  }
}

export default ManageSelectedDevices;
